import { ChildModel, ModelBase } from 'store/model-base';
import { NowNotificationBanner } from './banner';

export class NowNotificationBannerCollection extends ModelBase {
    public static storeName: string = 'nowNotificationBannerCollection';
    public static idAttribute: string = 'lineId';

    public lineId: string;
    public notificationCards: NowNotificationBanner[];

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.notificationCards = data.notificationCards || [];

        const toReturn: NowNotificationBannerCollection = super.create<NowNotificationBannerCollection>(data);

        return super.create<T>(toReturn);
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'notificationCards',
            model: NowNotificationBanner
        }];
    }

}
